<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="licensing-posture-total-wrapper stats-component">
  <div class="licensing-posture-title">
    <span class="draggable">{{'licensing-posture.title' | translate}}</span>
  </div>
  <!-- The draggable class above was moved outside of the async below so gridstack
        will see it, otherwise the entire component is draggable -->
  <div *ngrxLet="licensingPostureResult$ as licensingPostureResult" class="licensing-posture-data-wrapper">
      <h2 *ngIf="chooseCustomer; else haveCustomerData" class="title">{{'dashboard.select-a-customer' | translate}}</h2>
      <ng-template #haveCustomerData>
          <div class="licensing-posture-chart-wrapper">
              <div #containerRef class="chart-area" [ngStyle]="{'height': graphStyle}">
                  <div *ngIf="hasData(licensingPostureResult); else noData" class="chart">
                      <ngx-charts-pie-chart
                              [view]="[containerRef.offsetWidth, containerRef.offsetHeight]"
                              [results]="licensingPostureResult?.chartData"
                              [legend]="showLegend"
                              [labels]="showLabels"
                              [doughnut]="isDoughnut"
                              [legendPosition]="legendPosition"
                              legendTitle=""
                              arcWidth=".34"
                              (select)="onClick($event)"
                              [scheme]="colorScheme">
                      </ngx-charts-pie-chart>
                  </div>
                  <ng-template #noData>
                      <div *ngIf="licensingPostureResult" class="no-chart-data">
                          <span>{{'licensing-posture.no-data' | translate}}</span>
                      </div>
                  </ng-template>
              </div>
              <div class="licensing-posture-relative-changes-wrapper">
                  <div class="licensing-posture-relative-changes-text">
                      <div>
                          <div class="sub-title">{{'licensing-posture.subtitle' | translate}}</div>
                          <div>
                              <div class="data">{{'TOTAL' | translate}} - {{licensingPostureResult?.response.total}}</div>
                              <div class="data">{{'COMPLIANT' | translate}} - {{licensingPostureResult?.response.compliant}}</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </ng-template>
  </div>
</div>